import script from "./SummaryTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryTabs.vue?vue&type=script&setup=true&lang=js"

import "./SummaryTabs.vue?vue&type=style&index=0&id=e10f6512&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e10f6512"]])

export default __exports__